import {
  useEffect,
  useState
} from 'react'

export const useVisualViewport = () => {
  const [viewport, setViewport] = useState({
    height: window.innerHeight,
    offsetTop: 0
  })

  useEffect(() => {
    if (!window.visualViewport) return undefined

    const vv = window.visualViewport

    const update = () => {
      setViewport({
        height: vv.height,
        offsetTop: vv.offsetTop
      })
    }

    update()
    vv.addEventListener('resize', update)
    vv.addEventListener('scroll', update)

    return () => {
      vv.removeEventListener('resize', update)
      vv.removeEventListener('scroll', update)
    }
  }, [])

  return viewport
}
